export const MAKE_TARGETS = ['init', 'plan', 'apply'] as const

export const formatPartnerOrgName = (awsAccountName: string) =>
  awsAccountName.toLowerCase().trim().replace(/\s+/g, '-')

export const getTerraformTarget = (deploymentEnv: string) => {
  if (deploymentEnv === 'prd' || deploymentEnv === 'prod') {
    return 'prod'
  }
  if (deploymentEnv === 'q1' || deploymentEnv === 'q2') {
    return 'qa'
  }
  return deploymentEnv
}

export const buildTerraformCommand = (
  target: (typeof MAKE_TARGETS)[number],
  accountId: string,
  clientExternalId: string,
  partnerOrgName: string,
  terraformTarget: string
) => {
  const envVars = ` ACCOUNT_ID=${accountId} CLIENT_EXTERNAL_ID=${clientExternalId} PARTNER_ORG_NAME=${partnerOrgName} TARGET=${terraformTarget} TF_STATE_AWS_REGION=us-west-2`
  return {
    command: `make ${target}${envVars}`,
    envVars,
  }
}
